import Color from "color";

const lightContrastColor = "#000000";

interface Shop {
  color?: string;
}

export default (shop?: Shop) => {
  if (!shop) {
    return null;
  }

  const { color } = shop;
  const style = document.documentElement.style;

  if (color) {
    style.setProperty("--brand-color", color);
    style.setProperty("--brand-color-light", `${color}20`);

    if (Color(color).isLight()) {
      style.setProperty("--brand-contrast-color", lightContrastColor);
      style.setProperty("--brand-action-color", lightContrastColor);
    } else {
      style.setProperty("--brand-action-color", color);
    }
  }
}
